import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname"

export default function rewardWalletTransactionToString(receivers, formatMessage) {
  if (receivers.length === 1) {
    return formatMessage(
      {id: "wallet.utils.rewardWalletTransactionToString.oneRecognised"},
      {rewardedNameOne: firstnameLastname(receivers[0])}
    )
  }
  if (receivers.length === 2) {
    return formatMessage(
      {id: "wallet.utils.rewardWalletTransactionToString.twoRecognised"},
      {rewardedNameOne: firstnameLastname(receivers[0]), rewardedNameTwo: firstnameLastname(receivers[1])}
    )
  }
  if (receivers.length === 3) {
    return formatMessage(
      {id: "wallet.utils.rewardWalletTransactionToString.threeRecognised"},
      {
        rewardedNameOne: firstnameLastname(receivers[0]),
        rewardedNameTwo: firstnameLastname(receivers[1]),
        rewardedNameThree: firstnameLastname(receivers[2])
      }
    )
  }
  return formatMessage({id: "wallet.utils.rewardWalletTransactionToString.fourOrMore"}, {numberOfUsers: receivers.length})
}
